<template>
  <v-app>
    <v-main>
      <div v-if="application">
        <v-row
          v-if="!configureError"
          class="ma-0"
        >
          <v-col
            v-if="showPanel"
            :cols="12"
            :md="3"
            :xl="2"
            class="pb-0"
          >
            <search v-if="!config.hideTextFilter" />
            <facets v-if="config.filters.type === 'facets'" />
            <tree v-if="config.filters.type === 'tree'" />
          </v-col>
          <v-col v-if="dataset">
            <h4>{{ dataset && dataset.title }} - {{ count }} éléments</h4>
            <v-progress-linear
              :indeterminate="loading"
              :height="1"
              :color="loading ? 'primary' : 'transparent'"
            />
            <k-table />
          </v-col>
        </v-row>
        <v-img v-else-if="params('draft') === 'true'">
          <v-container class="px-5">
            <v-col class="text-center px-5 mb-5">
              <v-alert
                :value="true"
                type="warning"
                outlined
              >
                <h3>{{ configureError }}</h3>
              </v-alert>
            </v-col>
          </v-container>
        </v-img>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Search from './components/Search'
import Facets from './components/Facets'
import Tree from './components/Tree'
import KTable from './components/Table'

export default {
  name: 'App',
  components: {
    Search,
    Facets,
    Tree,
    KTable
  },
  computed: {
    ...mapState(['application', 'count', 'dataset', 'loading']),
    ...mapGetters(['config', 'datasetUrl']),
    configureError () {
      if (!this.datasetUrl) return 'Veuillez sélectionner une source de données'
      if (!this.config.columns || !this.config.columns.length) return 'Veuillez sélectionner au moins une colonne à afficher'
      return null
    },
    showPanel () {
      return !this.config.hideTextFilter || (this.config.filters.fields && this.config.filters.fields.length > 0)
    }
  },
  mounted () {
    if (!this.configureError) this.$store.dispatch('init')
  },
  methods: {
    params (p) {
      const params = new URLSearchParams(window.location.search)
      return params.get(p)
    }
  }
}
</script>
